/* eslint-disable max-len */

export default {
    name       : 'IntervenerParticipantAccounts',
    /**
     * @override
     */
    data() {
        return {
            uuid_intervener: null,
            participantsAccounts: [],
            isLoading: true
        };
    },
    props: {
        limit: {
            type: Number,
            required: false
        },
        id: {
            type: String,
            required: false
        }
    },
    methods: {
        /**
         * Obtenemos la información relativa a las cuentas participes del interviniente
         */
        fetchData() {
            const cfg = {};
            cfg.params = {};
            if (this.limit) {
                cfg.params.$limit = this.limit;
            }
            this.$intervenersService.getIntervenerParticipantAccounts(this.uuid_intervener, cfg)
                .then(res => {
                    this.processAccounts(res.data.intervener_accounts);
                });
        },
        /**
         * Procesa asíncronamente las cuentas obtenidas (para añadirles patrimonio)
         * @param {Object} accounts obtenidas para los intervinientes
         */
        async processAccounts(accounts) {
            Promise.all(
                await accounts.map(async item => {
                    item.id_object = item.account_data.id_object;
                    item.role = '';
                    for (let index = 0; index < item.account_intervener_role.length; index++) {
                        const rol = this.$t(`interveners.role.${item.account_intervener_role[index]}`);
                        item.role += `${rol}, `;
                    }
                    item.role = item.role.slice(0, -2);
                    item.distributor =  item.distributor_data ? item.distributor_data.key_name : '-';
                    item.status = item.account_data.status;
                    try {
                        await this.$accountsService.getAccountPositions(item.account_data.uuid, {})
                            .then(res => {
                                let patrimony = 0;
                                res.data.account_positions.forEach(element => {
                                    patrimony += Number(element.shares) * Number(element.nav);
                                });
                                item.patrimony = patrimony;
                            });
                    } catch {
                        // Sin saldo en la cuenta, no hacer nada
                    }
                    this.participantsAccounts.items.push(item);
                })
            ).then(() => this.isLoading = false);
        },
        /**
         *
         * @param {Object} data user row data
         */
        accountClick(data) {
            const item = {
                active: true,
                name: data.item.uuid_account,
                route: {
                    name: 'accounts_uuid_view',
                    query: {
                        name: data.item.id_object,
                        view: 'accounts-details',
                        id: data.item.uuid_account
                    },
                    force: true
                }
            };
            this.$router.push(item.route);
        },
        /**
         * Navigate to new account
         */
        async newAccount() {
            const defaultConfigUuid = '5271fc2d-f79c-4e25-bf50-31625b337c01';
            const res = await this.$onboardingService.getPublicConfiguration(defaultConfigUuid);
            const configFromDB = res.data.configuration.initial_configuration;
            const url = configFromDB.onboarding_path;
            url ? window.open(url) : null;
            return;
        }
    },
    /**
     * @override
     */
    beforeMount() {
        this.uuid_intervener = this.id || this.$route.params.uuid;
        this.participantsAccounts = {
            fields: [
                {
                    key: 'id_object',
                    label: 'ID Cuenta',
                    class: 'id_object'
                },
                {
                    key: 'account_data.alias_account',
                    label: 'Alias'
                },
                {
                    key: 'role',
                    label: 'Rol'
                },
                {
                    key: 'distributor',
                    label: 'Distribuidor'
                },
                {
                    key: 'patrimony',
                    label: 'Patrimonio',
                    tdClass: 'patrimony'
                },
                {
                    key: 'status',
                    label: 'Estado'
                }
            ],
            items: []
        };
        this.fetchData();
    }
};
